import React, { useEffect } from 'react';
import { string, bool, func } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources/react/dataModel/useDataModel';
import {
  alias,
  string as stringType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/utils';

const ScheduleAMeasure = ({
  itemId, onClick, hideBadge, hideContactInfo
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  const { storeId } = useStore();

  const opts = {
    variables: {
      itemId
    },
    ssr: false,
    skip: storeId === '8119'
  };
  const { data, loading, error } = useDataModel('clientOnlyProduct', opts);

  if (!itemId || error || loading || !data) {
    return null;
  }

  const {
    modelNumber
  } = data?.product?.identifiers;

  return (
    <CtaSection
      buttonText="Schedule a Measure"
      contactNumber="1-866-948-9023"
      buttonLink={buildSamLink(modelNumber)}
      hideBadge={hideBadge}
      hideContactInfo={hideContactInfo}
      openContentInOverlay={false}
      onClick={onClick}
    />
  );
};

ScheduleAMeasure.displayName = 'ScheduleAMeasure';

ScheduleAMeasure.dataModel = {
  clientOnlyProduct: alias('product').params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      modelNumber: stringType()
    })
  }),
};

ScheduleAMeasure.propTypes = {
  itemId: string.isRequired,
  onClick: func,
  hideBadge: bool,
  hideContactInfo: bool,
};

ScheduleAMeasure.defaultProps = {
  hideBadge: false,
  hideContactInfo: false,
  onClick: () => {},
};

export { ScheduleAMeasure };